import ModalProps from '../../../interfaces/ModalProps';

import { Button } from '~/components/ui/button';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '~/components/ui/dialog';
import { Text } from '~/components/ui/text';

interface ConfirmationModaltWithTriggerProps extends ModalProps {
  callTrigger: () => void;
  handleClose: () => void;
  headerText: string;
  alertText: string;
  buttonText1: string;
  buttonText2: string;
}

const ConfirmationModaltWithTrigger = ({
  open,
  callTrigger,
  handleClose,
  headerText,
  alertText,
  buttonText1 = 'OK',
  buttonText2 = 'Cancel',
}: ConfirmationModaltWithTriggerProps) => {
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) handleClose();
      }}
      open={open}
    >
      <DialogContent>
        <DialogTitle>{headerText}</DialogTitle>
        <Text className='text-gray-500 whitespace-pre-line'>{alertText}</Text>
        <DialogActions>
          <Button variant='outlined' color='neutral' onClick={handleClose}>
            {buttonText1}
          </Button>
          <Button variant='solid' color='secondary' onClick={callTrigger}>
            {buttonText2}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationModaltWithTrigger;
